import { Component, OnInit } from '@angular/core';
import { IEmployee } from 'ng2-org-chart/src/employee';
import { ContactInformationVipService, ScreenSaverService, CustomerService, CommonService } from 'src/app/shared';
import { environment } from '../../environments/environment';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
declare var jquery: any;
declare var $: any;
declare var Swal: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as QRCode from 'qrcode';
import * as moment from 'moment';

@Component({
  selector: 'app-set-screen-saver',
  templateUrl: './set-screen-saver.component.html',
  styleUrls: ['./set-screen-saver.component.css']
})
export class SetScreenSaverComponent implements OnInit { 

  contactInformationVip = {"name":"","description":""};
  addForm: FormGroup;
  editForm: FormGroup;
  submitted_add = false;
  submitted_edit = false;
  currentId;
  currentEditItem: any = null;
  isEditMode = false;
  fileName = 'Choose file';

  selectedFile: File | null = null;
  errorMessage = '';
  previewUrl: string | ArrayBuffer | null = null;

  readonly MAX_SIZE = 100 * 1024 * 1024; // 100MB
  readonly MAX_WIDTH = 1800;
  readonly MAX_HEIGHT = 1800;
  readonly ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'video/mp4', 'video/webm', 'video/ogg'];
  
    constructor(private fb: FormBuilder,
      private customerService: CustomerService,
      private screenSaverService: ScreenSaverService,
      private spinner: NgxSpinnerService,
      private commonService: CommonService,
      private contactInformationVipService: ContactInformationVipService) { 
      this.addForm = fb.group({
        'name': ['', Validators.required],
        'description': [''],
        'effect_expire_date': ['', Validators.required],
        'effect_date': ['', Validators.required],
        'expire_date': ['', Validators.required],
        'file': ['', Validators.required],
      });
  
      this.editForm = fb.group({
        'name': ['', Validators.required],
        'description': [''],
        'effect_expire_date': ['', Validators.required],
        'effect_date': ['', Validators.required],
        'expire_date': ['', Validators.required],
        'file': [''],
        'id': ['', Validators.required]
      });
    }
  
    ngOnInit() { 
      this.getAll();
      this.getDetail();
    }

    MAX_ITEMS = 0;
    MAX_VIDEO_ITEMS = 0;

    getDetail(){
      this.spinner.show();
      this.customerService.getCustomerDetail().subscribe(data=>{
        console.log(data)
        this.MAX_ITEMS = data.screen_saver_limit;
        this.MAX_VIDEO_ITEMS = data.video_saver_limit;
        this.spinner.hide();
      },
      err => {
        this.spinner.hide();
        console.log(err);
      });
    }

    get usedItems(): number {
      return this.dataList ? this.dataList.filter(i => i.file_type === 'image').length : 0;
    }

    get remainingItems(): number {
      return this.MAX_ITEMS - this.usedItems;
    }

    get usagePercent(): number {
      return Math.round(this.usedItems / this.MAX_ITEMS * 100);
    }

    get activeCount(): number {
      return this.dataList ? this.dataList.filter(i => i.status === 'active').length : 0;
    }

    get upcomingCount(): number {
      return this.dataList ? this.dataList.filter(i => i.status === 'upcoming').length : 0;
    }

    get expiredCount(): number {
      return this.dataList ? this.dataList.filter(i => i.status === 'expired').length : 0;
    }

  get usedVideoItems(): number {
    return this.dataList ? this.dataList.filter(i => i.file_type === 'video').length : 0;
  }

    get remainingVideoItems(): number {
      return this.MAX_VIDEO_ITEMS - this.usedVideoItems;
    }

    get videoUsagePercent(): number {
      return Math.round(this.usedVideoItems / this.MAX_VIDEO_ITEMS * 100);
    }
  
    dataList;
    originalOrder;
    orderChanged = false;
    dragIndex: number = null;
    dragOverIndex: number = null;

    onDragStart(index: number) {
      this.dragIndex = index;
    }

    onDragOver(event: DragEvent, index: number) {
      event.preventDefault();
      this.dragOverIndex = index;
    }

    onDrop(index: number) {
      if (this.dragIndex === null || this.dragIndex === index) return;
      const item = this.dataList.splice(this.dragIndex, 1)[0];
      this.dataList.splice(index, 0, item);
      this.orderChanged = true;
      this.dragIndex = null;
      this.dragOverIndex = null;
    }

    onDragEnd() {
      this.dragIndex = null;
      this.dragOverIndex = null;
    }

    saveOrder() {
      const orders = this.dataList.map((item, i) => ({ id: item.id, sort_order: i }));
      this.spinner.show();
      this.screenSaverService.updateOrder(orders).subscribe(() => {
        this.spinner.hide();
        this.orderChanged = false;
        this.originalOrder = [...this.dataList];
        this.successDialog();
      }, err => {
        this.spinner.hide();
        this.failDialog('');
      });
    }

    cancelOrder() {
      this.dataList = [...this.originalOrder];
      this.orderChanged = false;
    }

    getAll(){
      this.spinner.show();
      this.dataList = [];
      this.screenSaverService.getAll().subscribe(data=>{
        this.dataList = data;
        this.dataList.forEach(data => {
          data["url"] = environment.api_domain+"/api/v1/files-view/"+data.file_manager_id;
        });
        this.originalOrder = [...this.dataList];
        this.orderChanged = false;
        console.log(data);
        this.spinner.hide();
      },
      err => {
        this.spinner.hide();
        console.log(err);
      });
    }

    openCreate(){
      this.isEditMode = false;
      this.currentEditItem = null;
      this.fileName = 'Choose file';
      this.selectedFile = null;
      this.errorMessage = '';
      this.previewUrl= null;

      this.addForm.patchValue({
        name: "",
        description: "",
        effect_expire_date: this.commonService.convertDateToStrng(new Date())+" - "+this.commonService.convertDateToStrng(new Date()),
        effect_date: this.commonService.convertDateToStrng(new Date()),
        expire_date: this.commonService.convertDateToStrng(new Date()),
        file: null,
      });
      $('#modal-create').modal({
        backdrop: 'static',
        keyboard: false
      }).modal('show');
    }

  daterange: any = {};
  startDate;
  endDate;
  options: any = {
    locale: { format: 'DD-MM-YYYY' },
    alwaysShowCalendars: false,
  };
  selectedDateAdd(value: any, datepicker?: any) {
    // this is the date  selected
    console.log(value);
 
    // any object can be passed to the selected event and it will be passed back here
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.startDate = value.start._d;
    this.endDate = value.end._d;

    console.log(this.startDate);
    console.log(this.endDate);
    this.addForm.patchValue({
      effect_expire_date: this.commonService.convertDateToStrng(this.startDate)+" - "+this.commonService.convertDateToStrng(this.endDate),
      effect_date: this.commonService.convertDateToStrng(this.startDate),
      expire_date: this.commonService.convertDateToStrng(this.endDate)
    });
  }
  selectedDateEdit(value: any, datepicker?: any) {
    // this is the date  selected
    console.log(value);
 
    // any object can be passed to the selected event and it will be passed back here
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.startDate = value.start._d;
    this.endDate = value.end._d;

    console.log(this.startDate);
    console.log(this.endDate);
    this.editForm.patchValue({
      effect_expire_date: this.commonService.convertDateToStrng(this.startDate)+" - "+this.commonService.convertDateToStrng(this.endDate),
      effect_date: this.commonService.convertDateToStrng(this.startDate),
      expire_date: this.commonService.convertDateToStrng(this.endDate)
    });
  }

  previewIsVideo = false;
  onFileSelected(event: any) {
    this.errorMessage = '';
    this.previewUrl = null;

    const file: File = event.target.files[0];
    if (!file) {
      this.errorMessage = 'ไฟล์ไม่ถูกต้อง';
      this.selectedFile = null;
      this.previewUrl   = null;
      this.previewIsVideo = false;
      return;
    }

    // validate type
    if (!this.ALLOWED_TYPES.includes(file.type)) {
      this.errorMessage = 'ไฟล์ต้องเป็นรูปภาพ (JPG, PNG, GIF) หรือวิดีโอ (MP4, WEBM, OGG)';
      this.selectedFile = null;
      this.previewUrl   = null;
      this.previewIsVideo = false;
      return;
    }

    // validate size
    if (file.size > this.MAX_SIZE) {
      this.errorMessage = 'ขนาดไฟล์ต้องไม่เกิน 100 MB';
      return;
    }

    this.previewIsVideo = file.type.indexOf('video/') === 0;

    // คำนวณ limit โดยหักรายการเดิมออกในกรณี edit
    let imageRemaining = this.remainingItems;
    let videoRemaining = this.remainingVideoItems;
    if (this.isEditMode && this.currentEditItem) {
      if (this.currentEditItem.file_type === 'image') imageRemaining++;
      if (this.currentEditItem.file_type === 'video') videoRemaining++;
    }

    if (imageRemaining <= 0 && !this.previewIsVideo) {
      this.errorMessage = 'ไม่สามารถเพิ่มรูปภาพได้ เนื่องจากจำนวนรูปภาพถึงขีดจำกัดแล้ว';
      return;
    } else if (videoRemaining <= 0 && this.previewIsVideo) {
      this.errorMessage = 'ไม่สามารถเพิ่มวิดีโอได้ เนื่องจากจำนวนวิดีโอถึงขีดจำกัดแล้ว';
      return;
    }

    this.fileName       = file.name;
    this.selectedFile   = file;

    // // validate dimension
    // const reader = new FileReader();
    // reader.onload = (e: any) => {
    //   const img = new Image();
    //   img.onload = () => {
    //     // if (img.width > this.MAX_WIDTH || img.height > this.MAX_HEIGHT) {
    //     //   this.errorMessage = 'ขนาดรูปต้องไม่เกิน 180 x 180 px';
    //     //   return;
    //     // }

    //     this.selectedFile = file;
    //     this.previewUrl = e.target.result;
    //   };
    //   img.src = e.target.result;
    // };
    // reader.readAsDataURL(file);

    const reader = new FileReader();
    reader.onload = (e: any) => { this.previewUrl = e.target.result; };
    reader.readAsDataURL(file);
  }


    create(){
      console.log(this.addForm.value);
      this.submitted_add = true;
      if(this.addForm.invalid){
        return;
      }
      // validate limit ก่อน submit
      if (this.selectedFile) {
        const isVideo = this.selectedFile.type.indexOf('video/') === 0;
        if (!isVideo && this.remainingItems <= 0) {
          this.failDialog('ไม่สามารถเพิ่มรูปภาพได้ เนื่องจากจำนวนรูปภาพถึงขีดจำกัดแล้ว');
          return;
        }
        if (isVideo && this.remainingVideoItems <= 0) {
          this.failDialog('ไม่สามารถเพิ่มวิดีโอได้ เนื่องจากจำนวนวิดีโอถึงขีดจำกัดแล้ว');
          return;
        }
      }
      console.log(this.addForm.value);
      const formData = new FormData();
      if (this.selectedFile) {
        formData.append('file', this.selectedFile);
      }
      formData.append('name', this.addForm.value.name);
      formData.append('description', this.addForm.value.description);
      formData.append('effect_date', this.addForm.value.effect_date);
      formData.append('expire_date', this.addForm.value.expire_date);

      this.spinner.show();
      this.screenSaverService.create(formData).subscribe(data => {
        this.submitted_add = false;
        this.spinner.hide();
        $('#modal-create').modal('hide');
        this.getAll();
        this.successDialog();
      }, error => {
        console.error(error);
        this.spinner.hide();
        this.failDialog(error.expire_date[0]);
      });
    }
  
    openEdit(data){
      this.isEditMode = true;
      this.currentEditItem = data;
      this.selectedFile = null;
      const effectDateOnly = moment(data.effect_date, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY');
      const expireDateOnly = moment(data.expire_date, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY');

      const effectDate = moment(data.effect_date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
      const expireDate = moment(data.expire_date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');

      this.editForm.patchValue({
        id: data.id,
        name: data.name,
        description: data.description,
        effect_expire_date: effectDateOnly+" - "+expireDateOnly,
        effect_date: effectDate,
        expire_date: expireDate
      });

      this.previewUrl = environment.api_domain+"/api/v1/files-view/"+data.file_manager_id+ '?v=' + data.updated_at;
      this.previewIsVideo = data.file_type == 'video';

      $('#modal-edit').modal({
        backdrop: 'static',
        keyboard: false
      }).modal('show');
    }

    update(){
      console.log(this.editForm.value);
      this.submitted_edit = true;
      if(this.editForm.invalid){
        return;
      }
      // validate limit เมื่อเปลี่ยนไฟล์ประเภทใหม่
      if (this.selectedFile && this.currentEditItem) {
        const isVideo = this.selectedFile.type.indexOf('video/') === 0;
        let imageRemaining = this.remainingItems;
        let videoRemaining = this.remainingVideoItems;
        // หักรายการเดิมออก
        if (this.currentEditItem.file_type === 'image') imageRemaining++;
        if (this.currentEditItem.file_type === 'video') videoRemaining++;

        if (!isVideo && imageRemaining <= 0) {
          this.failDialog('ไม่สามารถเปลี่ยนเป็นรูปภาพได้ เนื่องจากจำนวนรูปภาพถึงขีดจำกัดแล้ว');
          return;
        }
        if (isVideo && videoRemaining <= 0) {
          this.failDialog('ไม่สามารถเปลี่ยนเป็นวิดีโอได้ เนื่องจากจำนวนวิดีโอถึงขีดจำกัดแล้ว');
          return;
        }
      }

      console.log(this.editForm.value);
      console.log(this.selectedFile);
      const formData = new FormData();
      formData.append('id', this.editForm.value.id);
      if (this.selectedFile) {
        formData.append('file', this.selectedFile);
      }
      formData.append('name', this.editForm.value.name);
      formData.append('description', this.editForm.value.description);
      formData.append('effect_date', this.editForm.value.effect_date);
      formData.append('expire_date', this.editForm.value.expire_date);

      this.spinner.show();
      this.screenSaverService.update(formData).subscribe(data => {
        this.submitted_edit = false;
        this.spinner.hide();
        $('#modal-edit').modal('hide');
        this.getAll();
        this.successDialog();
      }, error => {
        console.error(error);
        this.spinner.hide();
        this.failDialog(error.expire_date[0]);
      });
    }
  
    openDelete(id){
      this.currentId = id;
      $('#modal-remove').modal('show');
    }
  
    delete(){
      this.spinner.show();
      this.screenSaverService.delete(this.currentId).subscribe(data => {
        this.spinner.hide();
        $('#modal-remove').modal('hide');
        this.successDialog();
        this.getAll();
      }, error => {
        console.error(error);
        this.spinner.hide();
        this.failDialog('');
      });
    }
  
    successDialog(){
      Swal.fire("ทำรายการสำเร็จ!", "", "success");
    }
  
    failDialog(msg){
      Swal.fire({
        type: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: msg
      })
    }
  
  }
